module.exports = __webpack_public_path__ + "img/em-tempering-technology-01.9eea6fee.jpeg";